import {
  baseBookingUrls,
  baseUrls,
  checkInBaseUrls,
  coreApiBaseUrls,
  gtmIds,
  innerCirclePaths,
  receptionBaseUrls,
  secureFieldsHosts,
  turnstileSiteKeys
} from '@/constants/common';

import {
  getAnalyticsEnvironment,
  getEnvironment,
  getRealEnvironment,
  isKenticoProductionHostname
} from './environment';

export function getBaseUrl(language: string): string {
  const environment = getRealEnvironment();

  switch (language) {
    case 'de': {
      return `${baseUrls[environment]}/de`;
    }

    default: {
      return baseUrls[environment];
    }
  }
}

export function getBaseBookingUrl(): string {
  const environment = getEnvironment();

  return baseBookingUrls[environment];
}

export function getCoreApiBaseUrl(): string {
  const environment = getEnvironment();

  return coreApiBaseUrls[environment];
}

export function getBaseCheckInUrl(): string {
  const environment = getEnvironment();

  return checkInBaseUrls[environment];
}

export function getBaseReceptionUrl(): string {
  const environment = getEnvironment();

  return receptionBaseUrls[environment];
}

export function getGtmId() : string {
  const environment = getAnalyticsEnvironment();

  return gtmIds[environment];
}

export function getReturnUrl(baseUrl: string): string {
  const returnUrl = `${baseUrl}${window.location.pathname}${window.location.search}`;

  return encodeURIComponent(returnUrl);
}

export function getSecureFieldsHost() : string {
  const environment = getEnvironment();

  return secureFieldsHosts[environment];
}

export function getSignUpUrl(redirectUrl?: string): string {
  const receptionBaseUrl = getBaseReceptionUrl();
  const signUpUrl = `${receptionBaseUrl}${innerCirclePaths.signUp}`;

  if (redirectUrl === undefined) {
    return signUpUrl;
  }

  return `${signUpUrl}?redirectUrl=${redirectUrl}`;
}

export function getLogInUrl(redirectUrl?: string): string {
  const receptionBaseUrl = getBaseReceptionUrl();
  const logInUrl = `${receptionBaseUrl}${innerCirclePaths.logIn}`;

  if (redirectUrl === undefined) {
    return logInUrl;
  }

  return `${logInUrl}?redirectUrl=${redirectUrl}`;
}

export function getAccountUrl(): string {
  const receptionBaseUrl = getBaseReceptionUrl();

  return `${receptionBaseUrl}${innerCirclePaths.account}`;
}

export function getCheckInUrl(): string {
  const receptionUrl = getBaseReceptionUrl();

  return `${receptionUrl}/check-in`;
}

export function getGuestAreaStayUrl(slug: string): string {
  const receptionBaseUrl = getBaseReceptionUrl();

  return `${receptionBaseUrl}/stay?slug=${slug}`;
}

export function getGuestAreaStayPageUrl(slug: string, page: string): string {
  const receptionBaseUrl = getBaseReceptionUrl();

  return `${receptionBaseUrl}/stay/${page}?slug=${slug}`;
}

export function getCookieRootDomain() : string {
  const { hostname } = window.location;

  // Kentico stage host is not ours, so keep cookies host-only there
  if (isKenticoProductionHostname(hostname)) {
    return hostname;
  }

  switch (hostname) {
    // For homepage widgets
    case 'bobw.co':
    case 'booking.bobw.co': {
      return '.bobw.co';
    }

    case 'preview.bobw.co': {
      return 'preview.bobw.co';
    }

    case 'booking.staging-bobw.com': {
      return '.staging-bobw.com';
    }

    case 'booking.dukenukem.test-bobw.com': {
      return '.dukenukem.test-bobw.com';
    }

    default: {
      return 'localhost';
    }
  }
}

export function getCityTaxesUrl(language: string): string {
  const baseHostUrl = getBaseUrl(language);

  return `${baseHostUrl}/city-taxes`;
}

export function getTurnstileSiteKey() : string {
  const environment = getEnvironment();

  return turnstileSiteKeys[environment];
}
